export default[
    {
        path: 'reportCustomer',
        name: 'reportCustomer',
        component: () =>
        import(/* webpackChunkName: "productAuthorize" */ '@/views/company/productAuthorize/reportCustomer/index.vue'),
    },
    {
        path: 'projectList',
        name: 'projectList',
        component: () =>
        import(/* webpackChunkName: "productAuthorize" */ '@/views/company/productAuthorize/projectList/index.vue'),
    },
    {
        path: 'authorize',
        name: 'authorize',
        component: () =>
        import(/* webpackChunkName: "productAuthorize" */ '@/views/company/productAuthorize/authorize/index.vue'),
    },
    {
        path: 'deviceDriveBuy',
        name: 'deviceDriveBuy',
        component: () =>
        import(/* webpackChunkName: "productAuthorize" */ '@/views/company/productAuthorize/deviceDriveBuy/index.vue'),
    },
    {
        path: 'deviceDriveProject',
        name: 'deviceDriveProject',
        component: () =>
        import(/* webpackChunkName: "productAuthorize" */ '@/views/company/productAuthorize/driveLicense/ProjectList.vue'),
    },
    {
        path: 'driveLicenseProjectDetail',
        name: 'driveLicenseProjectDetail',
        component: () =>
        import(/* webpackChunkName: "productAuthorize" */ '@/views/company/productAuthorize/driveLicense/ProjectDetail.vue'),
    },
];
